import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { N0SsrPassengerUpdateRequest } from '@models/requests/ssr-passenger-update-request.model';
import { ApiResponse } from '@models/responses/api-response.model';
import { N0SsrAvailability } from '@models/responses/ssr-availability-response.model';
import { EnvironmentService } from '@services/environment-service/environment.service';
import { Observable } from 'rxjs';
import { AbandonedCartService } from "@services/abandoned-cart/abandoned-cart.service";
import { FALLBACK_CULTURE, RUDDERSTACK_USER_ID_QUERY_PARAM_NAME } from "@constants/app.constants";
import { RudderStackService } from "@services/rudderstack/rudderstack.service";

@Injectable({
  providedIn: 'root',
})
export class SsrService {
  private static readonly CONTROLLER_ROOT = 'v1/ssrs';

  constructor(
    private httpClient: HttpClient,
    private readonly abandonedCartService: AbandonedCartService,
    private readonly rudderStackService: RudderStackService,
  ) {}

  getAvailability(
    currencyCode: string,
  ): Observable<ApiResponse<N0SsrAvailability>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${SsrService.CONTROLLER_ROOT}/availability`;
    return this.httpClient.post<ApiResponse<N0SsrAvailability>>(endpoint, {
      currencyCode: currencyCode,
      ssrAvailabilityMode: 0,
    });
  }

  ssrUpdate(
    request: N0SsrPassengerUpdateRequest[],
    sendCartUpdatedEvent: boolean = false,
    cultureCode: string = FALLBACK_CULTURE,
  ): Observable<ApiResponse<null>> {
    const endpoint = `${EnvironmentService.environment.apiBaseUrl}${SsrService.CONTROLLER_ROOT}/update`;
    const params = this.getHttpParamsForSsrUpdate(sendCartUpdatedEvent, cultureCode);
    return this.httpClient.post<ApiResponse<null>>(endpoint, request, params ? {params} : {});
  }

  private getHttpParamsForSsrUpdate(sendCartUpdatedEvent: boolean, cultureCode: string): HttpParams | null {
    if (!sendCartUpdatedEvent) {
      return null;
    }
    let params = this.abandonedCartService.createHttpParamsWithAbandonedCartVariant();
    params = params.set('culture', cultureCode);
    params = params.set(RUDDERSTACK_USER_ID_QUERY_PARAM_NAME, this.rudderStackService.getAnonymousId() ?? '');
    params = params.set('sendCartUpdatedEvent', sendCartUpdatedEvent);
    return params;
  }
}
